{
  "type": "object",
  "name": "List",
  "class": "",
  "definitions": [
    {
      "type": "number",
      "name": "belegnummerHRGegenstueck",
      "title": "StreckenNr.",
      "class": ""
    },

    {
      "type": "date",
      "title": "Belegdatum",
      "name": "belegdatum",
      "class": ""
    },
    {
      "type": "string",
      "title": "Bezugsnummer",
      "name": "bezugsnummer",
      "class": "font-bold"
    },
    {
      "type": "fieldOk",
      "name": "ktostammUrsache",
      "title": "Lieferant",
      "format": "{{number}} - {{name}}",
      "fieldOk": "ktostamm.lieferant",
      "class": ""
    },
    {
      "type": "string",
      "title": "Belegnummer",
      "name": "belegnummer",
      "class": ""
    },
    {
      "type": "icon",
      "name": "icon",
      "icon": "fas fa-lock",
      "title": "Sperre",
      "class": "",
      "visible": {
        "name": "property",
        "property": "kzgesperrt",
        "rule": {
          "name": "boolean",
          "value": true
        }
      }
    },
    {
      "type": "date",
      "name": "faelldatum",
      "title": "Fälligkeit",
      "class": ""
    },
    {
      "type": "string",
      "title": "Objekt (Projektnummer in TR/SR)",
      "name": "objekt",
      "format": "{{objekt}}",
      "class": ""
    },
    {
      "type": "fieldOk",
      "name": "ktostammBaustelle",
      "title": "Baustelle",
      "format": "{{number}} - {{name}}",
      "fieldOk": "ktostamm.kunde.subnummer",
      "class": ""
    },
    {
      "type": "currency",
      "name": "saldo",
      "title": "Wert",
      "format": "1.2-2",
      "class": "",
      "titleClass": "text-right",
      "codeName": "EUR"
    }
  ]
}
